"use client";

import { LocalePillToggle } from "@/components/LocaleSwitcher/LocalePillToggle";
import { HeaderLanguageToggleFeature } from "@/components/LocaleSwitcher/HeaderLanguageToggleFeature";
import { useNavigationMessages } from "@/i18n/hooks/useNavigationMessages";

export default function MobileNavLanguageToggle() {
  const navMessages = useNavigationMessages();

  return (
    <HeaderLanguageToggleFeature>
      <div
        data-testid="mobile-nav-language-toggle"
        className="flex items-center justify-between border-b border-putty-400 px-4 py-3"
      >
        <span className="text-sm font-normal text-primary">
          {navMessages.mobileLanguageLabel}
        </span>
        <LocalePillToggle location="mobile-nav" />
      </div>
    </HeaderLanguageToggleFeature>
  );
}
